/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { HallowAnalyticsEvent, useAnalytics } from "@packages/analytics";
import { getDeviceType } from "@packages/sdk";
import {
  cssMediaQueryMinWidthTablet,
  DownloadAppButton,
  radius,
  spacing,
  stroke,
  useIsDesktopViewport,
} from "@packages/ui";

const containerStyles: Interpolation = {
  alignItems: "center",
  display: "flex",
  flexWrap: "wrap",
  gap: spacing.s,
  justifyContent: "space-evenly",
};

const downloadButtonStyles: Interpolation = {
  backgroundColor: "black !important",
  borderColor: `rgba(166, 166, 166, 1) !important`,
  borderRadius: radius.s,
  borderWidth: stroke.light,
  color: "white !important",
  paddingBottom: spacing.xxs,
  paddingLeft: spacing.xs,
  paddingRight: spacing.s,
  paddingTop: spacing.xxs,
  width: "100%",
  [cssMediaQueryMinWidthTablet]: {
    width: 136,
  },
};

export const MobileDownloadLinksClient = () => {
  const { track } = useAnalytics();
  const device = getDeviceType();
  const isDesktop = useIsDesktopViewport();

  return (
    (true || device !== "desktop" || !isDesktop) && (
      <div css={containerStyles}>
        <DownloadAppButton
          store="apple"
          css={downloadButtonStyles}
          onClickCapture={() => {
            track({
              event: HallowAnalyticsEvent.TappedDownloadOnTheAppStore,
              properties: {
                location: "community_thank_you",
              },
            });
          }}
        />
        <DownloadAppButton
          store="google"
          css={downloadButtonStyles}
          onClickCapture={() => {
            track({
              event: HallowAnalyticsEvent.TappedGetItOnGooglePlay,
              properties: {
                location: "community_thank_you",
              },
            });
          }}
        />
      </div>
    )
  );
};
